import React, { useMemo, useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Table from "../../../core/pagination/datatable";
import { reportConfigs } from "../../../core/json/reportconfig";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import GRAN_LOGO1 from "../Logo/Granules_logo1.png";
// import { Spin } from "antd";
import { Modal } from "antd";
import { getApiBaseUrl, ADD_ACTIVITY, LOGIN } from "../Config/Config";

const AssetReports = () => {
  const { reportType } = useParams();
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const user = JSON.parse(sessionStorage.getItem("user")) || {};

  const currentConfig = useMemo(() => {
    return reportConfigs.find((r) => r.ID == reportType);
  }, [reportType]);

  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    setLoading(true);
    if (currentConfig?.data) {
      setDataSource(currentConfig.data);
      setLoading(false);
    }
  }, [currentConfig]);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  console.log(loading);
  const tableColumns = useMemo(() => {
    return (
      currentConfig?.columns.map((col) => ({
        title: col.title,
        dataIndex: col.key,
        key: col.key,
        sorter: (a, b) => {
          const valA = a[col.key];
          const valB = b[col.key];
          return typeof valA === "number"
            ? valA - valB
            : String(valA).localeCompare(String(valB));
        },
      })) || []
    );
  }, [currentConfig]);

  const handleExportPDF = () => {
    const user = JSON.parse(sessionStorage.getItem("user")) || {
      UserName: "Unknown User",
    };

    const doc = new jsPDF();
    const logoWidth = 15;
    const logoHeight = 15;
    const pageWidth = doc.internal.pageSize.getWidth();

    const generateHeader = () => {
      doc.addImage(GRAN_LOGO1, "PNG", 10, 10, logoWidth, logoHeight);

      // Left section: Company Info
      doc.setFontSize(11);
      doc.text("Granules India Limited", 30, 14);
      doc.text("Gagillapur", 30, 20);

      // Right section: Report Meta Info
      doc.setFontSize(10);
      const rightX = pageWidth - 80; // adjust X position as needed
      doc.text(`Report Type: ${currentConfig?.reportType || "-"}`, rightX, 14);
      doc.text(`Printed by: ${user.UserName}`, rightX, 20);
      doc.text(`Date: ${new Date().toLocaleDateString("en-IN")}`, rightX, 26);

      // Title
      doc.setFontSize(13);
      doc.setFont(undefined, "bold");
      doc.text(`Title: ${currentConfig?.title || "Report"}`, 10, 35);
      doc.setFont(undefined, "normal");

      const y = 42;
      if (currentConfig?.showEquipmentId) {
        doc.setFontSize(11);
        doc.text(currentConfig.equipmentIdLabel || "Equipment ID:", 10, y);
        doc.text("", 70, y);
      }

      return y + 10;
    };

    const generateFooter = (pageNum, pageCount) => {
      const pageHeight = doc.internal.pageSize.height;
      const footerY = pageHeight - 20;

      doc.setFontSize(10);
      doc.text("Remarks:", 10, footerY - 10);
      doc.text(`Printed by: ${user.UserName}`, 10, footerY);
      doc.text(`Date Range: 01/01/2025 - 18/01/2025`, 10, footerY + 6);
      doc.text(
        `Printed on: ${new Date().toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
        })}`,
        10,
        footerY + 12
      );
      doc.text(
        `Page ${pageNum} of ${pageCount}`,
        pageWidth - 40,
        pageHeight - 10
      );
    };

    const startY = generateHeader();

    autoTable(doc, {
      startY: startY,
      head: [currentConfig.columns.map((col) => col.title)],
      // body: dataSource.map((item) =>
      //   currentConfig.columns.map((col) => item[col.key] ?? "")
      // ),

      body:
        dataSource.length > 0
          ? dataSource.map((item) =>
              currentConfig.columns.map((col) => item[col.key] ?? "")
            )
          : [
              [
                {
                  content: "Coming Soon",
                  colSpan: currentConfig.columns.length,
                  styles: { halign: "center" },
                },
              ],
            ],

      theme: "striped", //other styles are plain,grid (table with birders for rows and columns)
      headStyles: { fillColor: [22, 160, 133] },
      margin: {
        top: startY,
        bottom: 35,
      },
      didDrawPage: () => {
        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
        const totalPages = doc.internal.getNumberOfPages();

        generateHeader();
        generateFooter(pageNumber, totalPages);
      },
    });

    doc.save(`${currentConfig?.filename || "report"}.pdf`);
  };

  const handlePasswordSubmit = async () => {
    if (!password) {
      setPasswordError("Please enter your password");
      return;
    }

    setLoading(true);
    setPasswordError("");

    const username = user?.UserName || user?.Username;
    let loginSuccessful = false;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const loginData = await loginRes.json();

      if (loginData?.Message === "Login successful") {
        loginSuccessful = true;
      } else {
        setPasswordError(
          "Reauthentication failed. Please check your password."
        );
      }
    } catch (error) {
      console.error(error);
      setPasswordError("Something went wrong. Please try again.");
    }

    // Log activity regardless
    try {
      const activityPayload = {
        ActivityType: 1,
        PerformedBy: user?.UserID,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: loginSuccessful
          ? `${currentConfig?.title}  downloaded by ${username}`
          : `Failed Reauthentication for ${currentConfig?.title}  by ${username}`,
        Location: "Reports",
        IsSucces: loginSuccessful ? 1 : 0,
      };

      const actRes = await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(activityPayload),
      });

      const actData = await actRes.json();
      if (!actData?.success) {
        console.warn("Activity log failed");
      }
    } catch (err) {
      console.error("Activity log error", err);
    } finally {
      setLoading(false);
      if (loginSuccessful) {
        setVisible(false);
        setPassword("");
        handleExportPDF(); // trigger download
      }
    }
  };

  // 6️⃣ Render fallback if config is missing
  if (!currentConfig) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <h4 className="text-danger">Invalid report type: {reportType}</h4>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item" aria-current="page">
                    {currentConfig?.title}
                  </h4>
                </ol>
              </nav>
              <h6>Manage your reports</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link to="#" onClick={() => setVisible(true)}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set mt-5"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {/* {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: 300 }}
                >
                  <Spin tip="Loading Filter Status..." size="large" />
                </div>
              ) : (
                <Table columns={tableColumns} 
                dataSource={dataSource} 
                
                />
              )} */}
              {dataSource?.length > 0 ? (
                <Table columns={tableColumns} dataSource={dataSource} />
              ) : (
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {tableColumns.map((col) => (
                        <th key={col.key}>{col.title}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={tableColumns.length} className="text-center">
                        Coming Soon
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Confirm Password"
        open={visible}
        onCancel={() => {
          setVisible(false);
          setPassword("");
          setPasswordError("");
        }}
        onOk={handlePasswordSubmit}
        confirmLoading={loading}
        okText="Verify & Download"
        width={500}
      >
        <input
          type="password"
          className={`form-control ${passwordError ? "is-invalid" : ""}`}
          placeholder="Enter your password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (passwordError) setPasswordError(""); // clear on change
          }}
        />
        {passwordError && (
          <div className="invalid-feedback" style={{ display: "block" }}>
            {passwordError}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AssetReports;
